import {
  Component,
  OnInit,
  Input,
  ViewChild,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AccountDialogComponent } from './account-edit-dialog/account-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { ResizeEvent } from 'angular-resizable-element';
import { BankingDialogComponent } from '../../banking/banking-dialog.component';
import * as _ from 'lodash';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { BehaviorService } from '@_services/Behavior.service';
import { SortingBehaviourService } from '@_services/sorting-behaviour.service';
import { Subject, takeUntil } from 'rxjs';
import { DIALOG_WIDTH } from '@/app/_constant/dialog-width.constants';
@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AccountComponent implements OnInit, OnDestroy {
  @Input() SettingForm: FormGroup;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<any>;
  isExpandedRow = (_index: number, row: any): boolean => !!row?.expanded;
  highlightedRows: any;
  isLoadingResults: boolean = false;
  accountData: any = [];
  pageSize: any;
  PassArray: any = [];
  FinalList: any = [];
  theme_type: string | null = localStorage.getItem('theme_type');
  selectedColore: string = 'var(--highlighted-bg-row)';
  contectTitle: string = this.theme_type == 'theme-default' ? 'Solicitor' : 'Client';
  displayedColumns: string[] = [
    'ACTIVITY',
    'DESCRIPTION',
    'ACCOUNTTYPE',
    'ACCOUNTNO',
    'ACCOUNTNAME',
  ];
  INDEX: any;
  sortingDefaultState: any = {};
  sortactive: any;
  sortDirection: any;
  maintainFlag: boolean = false;
  public accDialoge = {
    Name: ' ',
    AccNo: ' ',
    AccType: ' ',
  };
  Gloabledata: any;
  SendArray: any = [];
  accountDialoge: any = [];
  showdiv: boolean = true;
  class: boolean;
  isspiner: boolean = false;
  private _unsubscribeAll$: Subject<void> = new Subject();
  tempArrayAccountGroup: any = {};
  currentUSer: any = JSON.parse(localStorage.getItem('currentUser'));

  constructor(
    public dialog: MatDialog,
    private _mainAPiServiceService: MainAPiServiceService,
    private toaster: ToastrService,
    private toastr: ToastrService,
    public behaviorService: BehaviorService,
    private SortingbehaviorService: SortingBehaviourService,
    private cd: ChangeDetectorRef,
  ) {
    localStorage.setItem('istrackid', 'SystemSettingAccountsComponent');
    this.SortingbehaviorService.accountSystemSorting$
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (result: any) => {
          if (result) {
            this.sortingDefaultState = result;
            localStorage.setItem('account_system_screen_sorting', JSON.stringify(result));
          } else {
            this.sortingDefaultState = JSON.parse(
              localStorage.getItem('account_system_screen_sorting'),
            );
          }
          this.cd.markForCheck();
        },
      });
  }

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    this.behaviorService.permissionCheckforHeight$
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (data: any) => {
          this.class = data;
          this.cd.markForCheck();
        },
      });

    if (this.sortingDefaultState) {
      this.sortactive = this.sortingDefaultState.active;
      this.sortDirection = this.sortingDefaultState.direction;
    } else {
      this.sortactive = '';
      this.sortDirection = '';
    }
    this.LoadData();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  async sortData(val: any) {
    await this.SortingbehaviorService.accountSystemSorting(val);
    this.cd.markForCheck();
  }

  /**
   * load the data of default accounts
   */
  LoadData() {
    // this.TaskAllData=[];
    this.isLoadingResults = true;
    let data = {
      Action: 'GetData',
      Filters: {
        GroupName: 'DefaultAccounts',
      },
    };
    this._mainAPiServiceService
      .getSetData(data, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (res: any) => {
          if (res.CODE == 200 && res.STATUS == 'success') {
            let apiData = res.DATA.RECORDS;
            apiData.forEach((element: any) => {
              this.FinalList.push(element);
            });

            apiData.forEach((element: any, i: any) => {
              element['expanded'] = false;
              element['id'] = i;
              this.FinalList = apiData;
            });
            this.maintainFlag = false;
            this.FinalList = new MatTableDataSource(apiData);
            this.FinalList.sort = this.sort;
            this.FinalList.paginator = this.paginator;
            // this.behaviorService.SysytemAccountData(this.FinalList.data);
            if (apiData[0]) {
              this.accountrow(apiData[0], 0);
              this.behaviorService.SysytemAccountData(apiData);
              this.highlightedRows = 0;
              this.behaviorService.loadingSystemSetting('account');
            }
          }
          this.isLoadingResults = false;
          this.cd.markForCheck();
        },
        error: (err: any) => {
          this.isLoadingResults = false;
          this.toastr.error(err);
          this.cd.markForCheck();
        },
      });
    this.pageSize = JSON.parse(localStorage.getItem('lastPageSize'));
  }

  /**
   * This function is used to ondialog Click
   */
  ondialogClick(): void {
    const dialogRef = this.dialog.open(AccountDialogComponent, {
      disableClose: true,
      data: { action: '' },
      panelClass: 'dialog-panel-class',
      backdropClass: 'cdk-overlay-dark-backdrop',
    });
    dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        localStorage.setItem('istrackid', 'SystemSettingAccountsComponent');
        if (result && result.length > 0) {
          this.FinalList.data[this.INDEX].ACCOUNTNAME = result[0].ACCOUNTNAME;
          this.FinalList.data[this.INDEX].ACCOUNTNO = result[0].ACCOUNTNUMBER;
          this.FinalList.data[this.INDEX].ACCOUNTGUID = result[0].ACCOUNTGUID;
          this.FinalList.data[this.INDEX].ACCOUNTGUIDNAME = result[0].ACCOUNTGUIDNAME;
        }

        this.behaviorService.SysytemAccountData(this.FinalList.data);
        this.cd.markForCheck();
      },
    });
    this.accDialoge.Name = this.Gloabledata.DESCRIPTION;
    this.accDialoge.AccNo = this.Gloabledata.ACCOUNTNO;
    this.accDialoge.AccType = this.Gloabledata.ACCOUNTTYPE;
  }

  /**
   * This function is used to accountrow data value get.
   */
  accountrow(val: any, index: any): void {
    this.INDEX = index;
    this.Gloabledata = val;
    this.accDialoge.Name = this.Gloabledata.DESCRIPTION;
    this.accDialoge.AccNo = this.Gloabledata.ACCOUNTNO;
    this.accDialoge.AccType = this.Gloabledata.ACCOUNTTYPE;
    this.behaviorService.SysytemAccountDIalogData(val);
    this.cd.markForCheck();
  }

  save() {
    // let data1 = { FormAction: "update", VALIDATEONLY: true, Data:this.FinalList.data[this.INDEX] }
    // this._mainAPiServiceService.getSetData(data1, 'SetSystem').subscribe(response=>{
    //   // this.getDropDownValue=response.DATA.LISTS;
    //   // this.getMatterClass(response);
    //    })
  }

  /**
   * This function is used to change the Pagination data
   */
  onPaginateChange(event: any): void {
    this.pageSize.account_page = event.pageSize;
    localStorage.setItem('lastPageSize', JSON.stringify(this.pageSize));
    this.cd.markForCheck();
  }

  /**
   * This function is used to Resize the End data value.
   */
  onResizeEnd(event: ResizeEvent, columnName: any): void {
    if (event.edges.right) {
      const cssValue = event.rectangle.width + 'px';
      const columnElts = document.getElementsByClassName('mat-column-' + columnName);
      for (let i = 0; i < columnElts.length; i++) {
        const currentEl = columnElts[i] as HTMLDivElement;
        currentEl.style.width = cssValue;
      }
    }
    this.cd.markForCheck();
  }

  /**
   * This function is used to Toggle the row data value.
   */
  toggleRow(element: any) {
    this.maintainFlag = false;
    if (element.expanded == true) {
      element.expanded = !element.expanded;
    } else {
      this.FinalList.filteredData.forEach((row: any) => {
        row.expanded = false;
      });
      element.expanded = !element.expanded;
    }
    this.table?.renderRows();
    this.cd.markForCheck();
  }

  /**
   * This function is used to get the Value.
   */
  async getValue() {
    // await this.itemChange('add');
    this.maintainFlag = true;
    this.FinalList.filteredData.forEach((row: any) => {
      row.expanded = false;
    });
    this.table?.renderRows();
    this.cd.markForCheck();
  }
  ChartHandlingData: {
    ClickType: string;
    UseTrust: string;
    PopUp: string;
    Lable: string;
  };

  /**
   * This function is used to Open the Account data value.
   */
  openAccount(type: any) {
    this.SendArray = [];
    this.ChartHandlingData = {
      ClickType: 'WithoutTrust',
      UseTrust: 'No',
      PopUp: '',
      Lable: 'Select Account',
    };
    localStorage.setItem('ChartURL', JSON.stringify(this.ChartHandlingData));
    this.behaviorService.trustDuplicateModuleHandling(this.ChartHandlingData);
    const dialogRef = this.dialog.open(BankingDialogComponent, {
      disableClose: true,
      width: DIALOG_WIDTH.W900,
      data: { AccountType: type, FromWhere: 'systemSetting' },
      panelClass: 'dialog-panel-class',
      backdropClass: 'cdk-overlay-dark-backdrop',
    });
    //this.accDialoge.AccNo=result.name;
    dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        localStorage.setItem('istrackid', 'SystemSettingAccountDialogComponent');
        if (result) {
          // this.accDialoge.AccNo = result.name;
          this.accDialoge.AccNo =
            result.ACCOUNTCLASS + ' - ' + result.ACCOUNTNUMBER + ' ' + result.ACCOUNTNAME;
          this.SendArray.push({
            ACCOUNTNUMBER: result.ACCOUNTCLASS + ' - ' + result.ACCOUNTNUMBER,
            ACCOUNTNAME: result.ACCOUNTNAME,
            ACCOUNTGUID: result.ACCOUNTGUID,
            ACCOUNTGUIDNAME: this.Gloabledata.ACCOUNTGUIDNAME,
          });
        }
        this.cd.markForCheck();
      },
    });
  }

  /**
   * function is called when user click on save button of particular element to save the data
   */
  async updateData() {
    this.tempArrayAccountGroup = {};
    this.tempArrayAccountGroup['GroupName'] = 'DefaultAccounts';
    localStorage.setItem('istrackid', 'SystemSettingAccountsComponent');
    if (this.SendArray.length != 0) {
      this.FinalList.data[this.INDEX].ACCOUNTNAME = this.SendArray[0].ACCOUNTNAME;
      this.FinalList.data[this.INDEX].ACCOUNTNO = this.SendArray[0].ACCOUNTNUMBER;
      this.FinalList.data[this.INDEX].ACCOUNTGUID = this.SendArray[0].ACCOUNTGUID;
      this.FinalList.data[this.INDEX].ACCOUNTGUIDNAME = this.SendArray[0].ACCOUNTGUIDNAME;
    }
    //  await  $('#callApiId').click();
    this.updateRecord(this.SendArray);
    // this.behaviorService.SysytemAccountData(this.FinalList.data);
    const finalData = this.FinalList.data;
    finalData.forEach((element: any) => {
      let key = element.ACCOUNTGUIDNAME;
      let val = element.ACCOUNTGUID;
      this.tempArrayAccountGroup[key] = val;
    });
    this.FinalList.filteredData.forEach((row: any) => {
      row.expanded = false;
    });
    this.table?.renderRows();
    this.cd.markForCheck();
  }

  /**
   * function is called when user click on save button to update particular record of invoice
   * @param record parameter of selected record
   */
  updateRecord(record: any) {
    let tempArrayAccountGroup: any = {};
    let key: any;
    let value: any;
    record.forEach((element: any) => {
      key = element.ACCOUNTGUIDNAME;
      value = element.ACCOUNTGUID;
      tempArrayAccountGroup['GroupName'] = 'DefaultAccounts';
      tempArrayAccountGroup[key] = value;
    });
    let data1 = {
      Action: 'Update',
      Data: tempArrayAccountGroup,
    };
    this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.isspiner = false;
            this.toastr.success('Updated successfully');
          } else if (
            (response.CODE == 451 || response.CODE == 450) &&
            response.STATUS == 'warning'
          ) {
            this.isspiner = false;
            this.toastr.warning(response.MESSAGE);
          } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
            this.isspiner = false;
            this.toastr.warning(response.MESSAGE);
          } else {
            this.isspiner = false;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspiner = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  /**
   * save the data of particular account
   */
  saveAccount() {
    this.isspiner = true;
    let data1 = { Action: 'Update', Data: this.tempArrayAccountGroup };
    this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.isspiner = false;
            this.currentUSer['DISBURSEMENTACCOUNTGUID'] =
              this.tempArrayAccountGroup.DISBURSEMENTACCOUNT;
            localStorage.setItem('currentUser', JSON.stringify(this.currentUSer));
            this.toastr.success('Updated successfully');
          } else if (
            (response.CODE == 451 || response.CODE == 450) &&
            response.STATUS == 'warning'
          ) {
            this.isspiner = false;
            this.toastr.warning(response.MESSAGE);
          } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
            this.isspiner = false;
            this.toastr.warning(response.MESSAGE);
          } else {
            this.isspiner = false;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspiner = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  /**
   * This function is used to Cancel Data value.
   */
  cancleData() {
    this.FinalList.filteredData.forEach((row: any) => {
      row.expanded = false;
    });
    this.table?.renderRows();
    this.cd.markForCheck();
  }
}
